// istanbul ignore file
import type { Revalidator, RevalidatorOptions, SWRConfiguration } from '@ori/fetching';

import type { ApiError } from '../models';

/**
 * SWR config
 */
export const swrConfig: SWRConfiguration = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,
  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: (
    error: ApiError,
    key: string,
    config: SWRConfiguration,
    revalidate: Revalidator,
    { retryCount }: RevalidatorOptions,
  ) => {
    const statusCode = Number(error.data.status ?? 200);
    if (statusCode >= 400 && statusCode < 500) {
      return;
    }
    const rCount = retryCount ?? 1;
    if (rCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({ retryCount: rCount }), config.errorRetryInterval);
  },
  /* eslint-enable max-params */
};
